<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ErrorWrapper } from '@utils/error-handler'
import {
  userComputed,
  userListMethod,
  authComputed,
  collegeComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'HOD & Teacher List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      isLoading: true,
      userlist: {},
      allUserList: {},
      collegelist: [],
      collegeId: 'All',
      platformId: 'All',
      isUserAdmin: false,
      siteconfiglist: [],
      allCollegeList: [],
      fields: [
        {
          value: 'first_name',
          text: 'First Name',
          sortable: true,
          colType: 'default',
        },
        { value: 'email', text: 'Email', sortable: true, colType: 'default' },
        {
          value: 'department',
          text: 'Department',
          sortable: false,
          colType: 'default',
        },
        { value: 'phone', text: 'Phone', sortable: true, colType: 'default' },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'first_name', label: 'Name', colType: 'default' },
        { key: 'college_name', label: 'College Name', colType: 'default' },
        { key: 'department', label: 'Department', colType: 'default' },
        { key: 'phone', label: 'Phone', colType: 'default' },
        { key: 'email', label: 'Email', colType: 'default' },
      ],
    }
  },
  computed: {
    ...userComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getListOfTeachers()
    this.getColleges()
  },
  methods: {
    ...userListMethod,
    ...collegeListMethod,
    ...siteListMethod,
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    getUsers() {
      if (this.collegeId !== 'All') {
        let listitems = []
        this.allUserList.docs.forEach((element) => {
          if (element.college_id === this.collegeId) {
            listitems.push(element)
          }
        })
        this.userlist.docs = listitems
      } else {
        if (this.role !== 'admin') {
          this.userlist.docs = this.allUserList.docs
        } else {
          let listitems = []
          this.allUserList.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              listitems.push(element)
            }
          })
          this.userlist.docs = listitems
        }
      }
    },

    getPlatformColleges() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allUserList.docs.forEach((element) => {
          if (element.platform_id === Number(this.platformId)) {
            listitems.push(element)
          }
        })
        this.userlist.docs = listitems
      } else {
        this.userlist.docs = this.allUserList.docs
      }
    },

    // Get list of all users role wise
    getListOfTeachers() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchTeacherList({ filter })
        .then((userList) => {
          this.userlist = JSON.parse(JSON.stringify(userList))
          this.allUserList = JSON.parse(JSON.stringify(this.userlist))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            &nbsp;&nbsp;&nbsp;<router-link
              v-if="role === 'college'"
              tag="button"
              to="/teacher-add"
              class="btn btn-info mb-2"
            >
              <i class="ti-plus"></i><span> Add HOD/Teacher</span>
            </router-link>
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformColleges"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              v-if="
                (role === 'admin' && isUserAdmin) || role === 'administrator'
              "
              label="Select College"
              label-for="input-1"
            >
              <b-form-select
                v-model="collegeId"
                :options="collegelist"
                style="width: 50%"
                @change="getUsers"
              ></b-form-select>
            </b-form-group>
            <Table
              :fields="fields"
              :items="userlist.docs"
              :editbtn="true"
              :viewbtn="true"
              :teacher="true"
              :deletebtn="true"
              :teacherlist="true"
              :display-fields="displayFields"
            >
            </Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
